import { Chip } from "@mui/material";
import { useSelector } from "react-redux";

const UserLevelChip = ({ level = 0 }) => {
	const levels = useSelector((state) => state.userLevel.levels);

	if (!levels || !level || levels.length === 0) return null;

	const matchedLevel = levels.find((l) => {
		return level >= l.startRange && level <= l.endRange;
	});
	if (!matchedLevel) return null;

	return (
		<Chip
			label={matchedLevel.name}
			sx={{
				backgroundColor: matchedLevel.color,
				minWidth: "70px",
				color: "white",
				fontWeight: "bold",
				fontSize: "1rem",
			}}
		/>
	);
};

export default UserLevelChip;
